import { flatMap, isEmpty } from 'lodash';
import { useIntl } from 'react-intl';
import { ButtonUI, useFeatureUser } from 'sonata-react-components';

import { withPlatformV2OriginMarker } from '@/helpers/navigation/platformOrigin.helper';
import { isSecondaryActionClick } from '@/helpers/navigation/secondaryAction.helper';
import { AggregatedReportStyled } from './AggregatedReport.styled';

import type { MouseEvent } from 'react';
import type { SelectedMultiflightEntity } from '@/store/local/campaigns';

type Props = {
  selectedEntities: SelectedMultiflightEntity[];
};

export default function AggregatedReport({ selectedEntities }: Props) {
  const { formatMessage } = useIntl();
  const showReportingV2 = useFeatureUser('reportingV2');
  const showReportingV2InV2 = useFeatureUser('reportingV2inV2');
  const MIN_SELECTED_ITEM = 2;

  const lineItemIds = [...new Set(flatMap(selectedEntities.map(entity => entity.lineItemIds)))];

  let reportingHref = '';
  if (showReportingV2InV2) {
    reportingHref = `/reporting?cids=${lineItemIds.join()}`;
  } else if (showReportingV2) {
    reportingHref = withPlatformV2OriginMarker(
      `${taptap.config.sonataUrl}app.html#!/reporting-v2&q=${lineItemIds.join()}`
    );
  } else {
    reportingHref = withPlatformV2OriginMarker(`${taptap.config.sonataUrl}app.html#!/reporting/${lineItemIds.join()}`);
  }

  const handleReportingClick = (ev: MouseEvent) => {
    if (isSecondaryActionClick(ev)) {
      window.open(reportingHref, '_blank', 'noopener,noreferrer');
    } else {
      window.location.assign(reportingHref);
    }
  };

  if (selectedEntities.length < MIN_SELECTED_ITEM || isEmpty(lineItemIds)) {
    return null;
  }

  return (
    <AggregatedReportStyled>
      <span
        onContextMenu={ev => {
          ev.preventDefault();
          handleReportingClick(ev);
        }}
      >
        <ButtonUI
          icon="fal fal fa-chart-column"
          iconPosition="left"
          onClick={handleReportingClick}
          shape="squareRounded"
          size="medium"
          text={formatMessage({
            defaultMessage: 'View Aggregated Report',
            id: 'common.aggregatedReportButton'
          })}
          type="secondary"
        />
      </span>
    </AggregatedReportStyled>
  );
}
